import kebabCase from 'lodash/kebabCase'
import startCase from 'lodash/startCase'
import uniqueId from 'lodash/uniqueId'

import EmptyChart from '../components/EmptyChart'
import Chart from '../views/Chart'

export default class ChartRoute {
  constructor ({ chart = EmptyChart, name = null, title = null } = { }) {
    this.chart = chart
    this.name = name || chart.name || uniqueId('route-')
    this.title = title || startCase(this.name)
  }

  get props () {
    return {
      default: route => {
        return ({
          socialMode: String(route.query.socialMode).toLowerCase() === 'true',
          noFooter: String(route.query.noFooter).toLowerCase() === 'true',
          chart: this.chart
        })
      }
    }
  }

  get component () {
    return Chart
  }

  get components () {
    return {
      default: this.component
    }
  }

  get id () {
    return kebabCase(this.name).toLowerCase()
  }

  get anchor () {
    return `#${this.id}`
  }

  get path () {
    return `/${this.id}`
  }

  get isEmpty () {
    return this.chart === EmptyChart
  }

  static create (...args) {
    return new ChartRoute(...args)
  }
}
